export default {
  "iframe": "Uf6-x"
};